import React from 'react';
import { ThemeProvider, createGlobalStyle } from 'styled-components/macro';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import { KnowledgeQuiz } from './components/KnowledgeQuiz';

const client = new ApolloClient({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    cache: new InMemoryCache(),
});

const theme = {
    colors: {
        brand: '#046a38',
        darkGreen: '#034725',
        green: '#8DC63F',
        lightGreen: '#e3f1d2',
        alt: '#009fe3',
        copy: '#222222',
        dark: '#222222',
        grey: '#E7E7E7',
        midGrey: '#CCCCCC',
        lightGrey: '#EEEEEE',
        white: '#fff',
        red: '#CD0A0A',
        lightRed: '#f4c6c7',
    },
    typography: {
        fontFamily: `'Veneer', sans-serif`,
        base: '14px',
        heading: {
            sm: '36px',
            lg: '36px',
        },
        subHeading: {
            sm: '24px',
            lg: '32px',
        },
        tagline: {
            sm: '16px',
            lg: '18px',
        },
    },
    breakpoints: {
        sm: 768,
        lg: 992,
    },
    space: {
        xxs: '4px',
        xs: '8px',
        sm: '16px',
        md: '24px',
        lg: '48px',
        xl: '72px',
    },
    borderRadius: {
        sm: '4px',
        md: '12px',
    },
};

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        font-family: Arial;
        * {
            box-sizing: border-box;
        }
    }
`;

const App = ({ trainingId }) => {
    console.log(trainingId);
    return (
        <ApolloProvider client={client}>
            <ThemeProvider theme={theme}>
                <GlobalStyle />
                <KnowledgeQuiz trainingId={trainingId} />
            </ThemeProvider>
        </ApolloProvider>
    );
};

export default App;
